import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorsLogComponent } from './errors-log.component';

const routes: Routes = [
  {
    path: '',
    component: ErrorsLogComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErrorsLogRoutingModule { }
